import React from "react";
import { Grid, Button } from "@material-ui/core";
import BackupIcon from "@material-ui/icons/Backup";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import { translate } from "react-i18next";

class FileAction extends React.Component {
  constructor(props) {
    super(props);
    this.handleFileChange = this.handleFileChange.bind(this);
  }
  handleFileChange(event) {
    const { onCreateFile, browserProps } = this.props;
    const { files } = event.target;
    const { selection } = browserProps;
    const prefix = selection[0] ? selection[0] : "";
    onCreateFile(files, prefix);
  }
  render() {
    const {
      onCreateFolder,
      t,
      allowCreateFile = true,
      allowCreateFolder = true,
    } = this.props;
    return (
      <Grid
        container
        style={{
          width: "fit-content",
        }}
        spacing={1}
      >
        {allowCreateFile && (
          <Grid item>
            <input
              accept="image/*"
              style={{
                display: "none",
              }}
              id="icon-button-file"
              type="file"
              onChange={this.handleFileChange}
            />
            <label htmlFor="icon-button-file">
              <Button
                variant="contained"
                size="small"
                color="primary"
                component="span"
                startIcon={<BackupIcon />}
              >
                {t("upload_image")}
              </Button>
            </label>
          </Grid>
        )}
        {allowCreateFolder && (
          <Grid item>
            <Button
              onClick={onCreateFolder}
              variant="contained"
              size="small"
              color="primary"
              startIcon={<CreateNewFolderIcon />}
            >
              {t("add_folder")}
            </Button>
          </Grid>
        )}
      </Grid>
    );
  }
}
export default translate("translations")(FileAction);
